import React from 'react';

import { useAppDispatch, useAppSelector } from '_lib/redux/hooks';

import { CustomerPane, CustomerPaneProps } from '../../../../common/CustomerPane/CustomerPane';
import {
  selectCustomerContext,
  selectPhoneCallContext,
  setCustomerContext,
  setCustomerContextLocations
} from '../../StCapacityPhoneCall.slice';

type StCapacityCustomerPaneProps = Omit<
  CustomerPaneProps,
  'customerContext' | 'location' | 'setCustomerContext' | 'setCustomerContextLocations'
>;

export const StCapacityCustomerPane = (props: StCapacityCustomerPaneProps) => {
  const dispatch = useAppDispatch();

  const customerContext = useAppSelector(selectCustomerContext);
  const phoneCallContext = useAppSelector(selectPhoneCallContext);

  return (
    <CustomerPane
      customerContext={customerContext}
      location={phoneCallContext.location}
      setCustomerContext={(customerContext) => {
        dispatch(setCustomerContext(customerContext));
      }}
      setCustomerContextLocations={(locations) => {
        dispatch(setCustomerContextLocations(locations));
      }}
      {...props}
    />
  );
};
